"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFiscalRegime = void 0;
exports.EFiscalRegime = {
    IRPP: "IRPP",
    BIC: "BIC",
    BNC: "BNC",
    IFI: "IFI",
    AUTRE_NON_RESIDENT: "AUTRE_NON_RESIDENT",
};
